export class NotificationScheduleOption {
  Id : number; 
	FrequencyType : string;
	FrequencyValue : number;
	ModuleType :string = 'Subscription';
	IsActive : boolean;
	IsDeleted: boolean;
	CreatedBy : number;
	UpdatedBy : number;
  saving: boolean;
}
